import { StandardConfigurationProjectSubTypeBase } from './base/standard-configuration-project-sub-type-base';

export class StandardConfigurationProjectSubType extends StandardConfigurationProjectSubTypeBase { }